import { combineReducers } from "redux";
import { fleetOverviewState } from "./fleetOverviewReducer";

export const fleetOverviewReducers = combineReducers({
    fleetOverviewState: fleetOverviewState
});
